// shared/ui/Campo.jsx  (etiqueta + valor de solo lectura para las vistas de detalle; vacío => "—")
import React from 'react';

const Campo = ({ label, value, span = 1 }) => (
  <div style={{ gridColumn: `span ${span}`, minWidth: 0 }}>
    <div style={{ fontSize: 12, color: '#6c757d' }}>{label}</div>
    <div style={{ fontSize: 15, color: '#212529', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{value || '—'}</div>
  </div>
);

export default Campo;
